module.exports = __webpack_public_path__ + "static/media/8.97ef5ae8.jpg";